import className from 'classnames';
import React from 'react';

const Pill = ({ checked, onChange, label }) => {
  return <div
    className={className('toggle-pill flex-center', { checked })}
    onClick={() => {
      if (onChange) {
        onChange()
      }
    }}>
    {label}
  </div>
}

export default Pill


// WEBPACK FOOTER //
// ./src/containers/components/pill.js